<template lang="html">
  <div class="page-section">
    <div class="container">
      <div class="team-members">
        <TeamMember
          :demoMode="demoMode"
          v-for="(member, index) in items"
          @highlightField="highlightField"
          :key="`team-member-${index}`"
          :member="member"/>
      </div>
    </div>
  </div>
</template>

<script>
import TeamMember from './TeamMember'

export default {
  name: 'TeamMembers',

  props: {
    demoMode: Boolean,

    currentListItem: {
      type: Object,
      description: 'This is the type of list'
    },

    items: {
      type: Array,
      description: 'The current list item'
    }
  },

  methods: {
    highlightField(value) {
      this.$emit('highlightField', value)
    }
  },

  components: {
    TeamMember
  }
}
</script>

<style lang="sass">
@import '../../../stylesheets/base/variables'
@import '../../../stylesheets/helpers/mixins'

.team-members
  @include media($media-gt-small)
    display: flex
    flex-wrap: wrap
    justify-content: center
    align-items: stretch
    align-content: stretch
</style>
